var _excluded = ["containerClassName", "maxChars", "minChars", "charExceededMessage", "autoSize", "type"];

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { BetterComponent } from '../better-component/better-component';
import { Input, InputNumber } from 'antd';
import * as React from 'react';
import './better-input.scss';
export var BetterInput = /*#__PURE__*/function (_BetterComponent) {
  _inherits(BetterInput, _BetterComponent);

  var _super = _createSuper(BetterInput);

  function BetterInput(props) {
    var _this;

    _classCallCheck(this, BetterInput);

    _this = _super.call(this, props);
    _this.state = {
      inputWidth: 45
    };
    _this.input = void 0;
    return _this;
  }

  _createClass(BetterInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          containerClassName = _this$props.containerClassName,
          _this$props$maxChars = _this$props.maxChars,
          maxChars = _this$props$maxChars === void 0 ? 0 : _this$props$maxChars,
          _this$props$minChars = _this$props.minChars,
          minChars = _this$props$minChars === void 0 ? 0 : _this$props$minChars,
          charExceededMessage = _this$props.charExceededMessage,
          autoSize = _this$props.autoSize,
          type = _this$props.type,
          props = _objectWithoutProperties(_this$props, _excluded);

      var input = this.input || {};
      var hasCharLimit = !!input && (!!maxChars || !!minChars);
      var isOutsideLimits = false;
      var charLength = 0;
      var currentValue = (input.value || '').trim();
      var macroDetected = /{{/.test(currentValue);

      if (!macroDetected && hasCharLimit) {
        charLength = currentValue.length;

        if (!isOutsideLimits && minChars) {
          if (charLength > 0 && charLength < minChars) {
            isOutsideLimits = true;
          }
        }

        if (!isOutsideLimits && maxChars) {
          if (charLength > 0 && charLength > maxChars) {
            isOutsideLimits = true;
          }
        }
      }

      var style = autoSize && this.state.inputWidth ? {
        width: this.state.inputWidth
      } : undefined;
      var InputComponent = Input;

      if (type === 'number') {
        InputComponent = InputNumber;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: ['sw-better-input', containerClassName || ''].join(' ').trim()
      }, /*#__PURE__*/React.createElement(InputComponent, _extends({}, props, {
        style: style,
        ref: function ref(el) {
          if (el) {
            if ('inputNumberRef' in el) {
              _this2.input = el.inputNumberRef.input;
            } else {
              _this2.input = el.input;
            }
          }
        },
        onChange: function onChange(ev) {
          if (autoSize) {
            _this2.resize(ev);
          }

          if (!!_this2.props.onChange) {
            _this2.props.onChange(ev);
          }
        }
      })), (macroDetected || hasCharLimit) && /*#__PURE__*/React.createElement("div", {
        className: ['sw-better-input-char-counter', isOutsideLimits ? 'outside-limits' : ''].join(' ').trim()
      }, macroDetected ? /*#__PURE__*/React.createElement("span", null, "Unable to calculate characters due to dynamic macro length") : /*#__PURE__*/React.createElement("span", null, charLength, " ", charLength === 1 ? 'Character' : 'Characters', isOutsideLimits && !!charExceededMessage ? ". ".concat(charExceededMessage) : '')));
    }
  }, {
    key: "resize",
    value: function () {
      var _resize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev) {
        var val, minWidth, inputWidth, shadowSpan, shadowWidth, valLength;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (ev) {
                  if (_typeof(ev) === 'object') {
                    val = ev.target.value;
                  } else {
                    val = ev;
                  }
                } else {
                  if (this.input) {
                    val = this.input.value;
                  }
                }

                minWidth = 45;
                inputWidth = minWidth;

                if (val) {
                  shadowSpan = document.createElement('span');
                  shadowSpan.innerText = val;
                  shadowSpan.setAttribute('style', 'visibility: hidden;position:absolute;z-index:-1;top:0;left:0;');
                  document.body.appendChild(shadowSpan);
                  shadowWidth = shadowSpan.offsetWidth;
                  document.body.removeChild(shadowSpan);
                  valLength = val.length;
                  inputWidth = shadowWidth + 36 + 1;

                  if (inputWidth < minWidth) {
                    inputWidth = minWidth;
                  }
                }

                return _context.abrupt("return", this.setState({
                  inputWidth: inputWidth
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function resize(_x) {
        return _resize.apply(this, arguments);
      }

      return resize;
    }()
  }]);

  return BetterInput;
}(BetterComponent);